// extracted by mini-css-extract-plugin
module.exports = {"addPatient_content":"addPatient_addPatient_content__192Qg","outer_form_tab":"addPatient_outer_form_tab__13hdi","block":"addPatient_block__PbxCr"};